import React from "react"
import Image1 from "../imageComponents/Image1"
import { Link } from "gatsby"

const JoinClub = ({ data }) => {
  return (
    <div className="col-span-full rounded-2xl overflow-hidden bg-white shadow-xl">
      <Link to="/club">
        <div className="lg:flex">
          <div className="lg:w-3/5">
            <Image1 />
          </div>

          <div className="p-5 mx-auto my-auto">
            <h2 className="font-extrabold tracking-tight text-gray-900 text-4xl">
              Join the club
            </h2>
            <br />
            <h2 className="font-bold tracking-tight text-gray-900 text-2xl">
              Our latest and greatest, delivered to your door
            </h2>
            <br />
            <h2 className="text-lg text-indigo-600 font-semibold ">
              Wine and cider clubs now enrolling
            </h2>
            <br />
            <Link
              to="/club"
              className="inline-flex items-center justify-center px-5 py-3 border border-transparent text-base font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700"
            >
              Join now
            </Link>
          </div>
        </div>
      </Link>
    </div>
  )
}

export default JoinClub
